import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableHeadSurveyor } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  ScrollToTop,
} from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Button,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";

const TampilHeadSurveyor = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const [isFetchError, setIsFetchError] = useState(false);
  const [isHeadSurveyorExist, setIsHeadSurveyorExist] = useState(false);
  const [kodeHeadSurveyor, setKodeHeadSurveyor] = useState("");
  const [namaHeadSurveyor, setNamaHeadSurveyor] = useState("");
  const [teleponHeadSurveyor, setTeleponHeadSurveyor] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [headSurveyorsData, setHeadSurveyorsData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    { title: "No", field: "no" },
    { title: "Kode", field: "kodeHeadSurveyor" },
    { title: "Nama Head Surveyor", field: "namaHeadSurveyor" },
    { title: "Telepon Head Surveyor", field: "teleponHeadSurveyor" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id ? getHeadSurveyorById() : setIsHeadSurveyorExist(false);
  }, [id]);

  useEffect(() => {
    getHeadSurveyor();
  }, [page, searchTerm]);

  const getHeadSurveyor = async () => {
    setLoading(true);
    try {
      const allHeadSurveyors = await axios.post(
        `${tempUrl}/headSurveyorsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      setQuery(searchTerm);
      setHeadSurveyorsData(allHeadSurveyors.data.headSurveyors);
      setPage(allHeadSurveyors.data.page);
      setPages(allHeadSurveyors.data.totalPage);
      setRows(allHeadSurveyors.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getHeadSurveyorsForDoc = async (isPdf, isExcel) => {
    setLoading(true);
    const allHeadSurveyorsForDoc = await axios.post(
      `${tempUrl}/headSurveyorsForDoc`,
      {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      }
    );
    setLoading(false);
    if (isPdf) {
      downloadPdf(allHeadSurveyorsForDoc.data);
    } else if (isExcel) {
      downloadExcel(allHeadSurveyorsForDoc.data);
    }
  };

  const getHeadSurveyorById = async () => {
    setLoading(true);
    if (id) {
      const pickedHeadSurveyor = await axios.post(
        `${tempUrl}/headSurveyors/${id}`,
        {
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      setIsHeadSurveyorExist(true);
      setKodeHeadSurveyor(pickedHeadSurveyor.data.kodeHeadSurveyor);
      setNamaHeadSurveyor(pickedHeadSurveyor.data.namaHeadSurveyor);
      setTeleponHeadSurveyor(pickedHeadSurveyor.data.teleponHeadSurveyor);
    }
    setLoading(false);
  };

  const deleteHeadSurveyor = async (id) => {
    const findSurveyorByKodeHeadSurveyor = await axios.post(
      `${tempUrl}/surveyorsByKodeHeadSurveyor`,
      {
        kodeHeadSurveyor: id,
        id: user._id,
        token: user.token,
      }
    );
    const findUserBykodeHeadSurveyor = await axios.post(
      `${tempUrl}/getUserBykodeHeadSurveyor`,
      {
        kodeHeadSurveyor: id,
        id: user._id,
        token: user.token,
      }
    );
    let isHeadSurveyorDataExist =
      findSurveyorByKodeHeadSurveyor.data.length > 0 ||
      findUserBykodeHeadSurveyor.data.length > 0;
    if (isHeadSurveyorDataExist) {
      // There's Record -> Forbid Delete
      handleClickOpen();
    } else {
      // No Record Found -> Delete
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/deleteHeadSurveyor/${id}`, {
          id: user._id,
          token: user.token,
        });
        setKodeHeadSurveyor("");
        setNamaHeadSurveyor("");
        setTeleponHeadSurveyor("");
        setLoading(false);
        navigate("/headSurveyor");
        getHeadSurveyor();
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
  };

  const downloadPdf = (data) => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Head Surveyor`, 90, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.setFontSize(12);
    let no = 0;
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: data.map((col) => {
        no++;
        return { ...col, no };
      }),
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `HeadSurveyor`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarHeadSurveyor.xlsx`);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Master</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Head Surveyor
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Tidak bisa dihapus karena sudah ada data!`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Nama HeadSurveyor data: ${namaHeadSurveyor}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            startIcon={<PrintIcon />}
            onClick={() => {
              getHeadSurveyorsForDoc(true, false);
            }}
          >
            CETAK
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => {
              getHeadSurveyorsForDoc(true, false);
            }}
          >
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={isHeadSurveyorExist}
          addLink={`/headSurveyor/tambahHeadSurveyor`}
          editLink={`/headSurveyor/${id}/edit`}
          deleteUser={deleteHeadSurveyor}
          nameUser={kodeHeadSurveyor}
        />
      </Box>
      <Divider sx={dividerStyle} />
      {isHeadSurveyorExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode Head Surveyor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeHeadSurveyor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Head Surveyor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={namaHeadSurveyor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Telepon :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={teleponHeadSurveyor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableHeadSurveyor currentPosts={headSurveyorsData} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilHeadSurveyor;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
